/* tslint:disable */
/* eslint-disable */
import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ActuatorService } from './services/actuator.service';
import { AuthService } from './services/auth.service';
import { ClientAuthService } from './services/client-auth.service';
import { UsersService } from './services/users.service';
import { RolesService } from './services/roles.service';
import { PrivilegesService } from './services/privileges.service';
import { ApplicationsService } from './services/applications.service';
import { UserGroupsService } from './services/user-groups.service';
import { ClientsService } from './services/clients.service';
import { PerDiemService } from './services/per-diem.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ActuatorService,
    AuthService,
    ClientAuthService,
    UsersService,
    RolesService,
    PrivilegesService,
    ApplicationsService,
    UserGroupsService,
    ClientsService,
    PerDiemService,
    ApiConfiguration,
  ],
})
export class ApiModule {
  static forRoot(
    params: ApiConfigurationParams
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error(
        'ApiModule is already loaded. Import in your base AppModule only.'
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
